import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';

// Marca PANETON WINTERS (los productos de panetones cuelgan de esta marca).
const PANETON_MARK_ID = 29;

export default WithApp(function ModalProductGroupPanettoneDetail(props) {
  const detail = props.model;
  const { id } = props;
  const [dataChanging, setDataChanging] = useState([]);
  const [products, setProducts] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listProducts() {
    let response = await wsFindBy('logi/product', { logi_mark_id: PANETON_MARK_ID, deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }

  useEffect(() => {
    if (detail.open) {
      setDataChanging([]);
      listProducts();
    }
  }, [detail.open]);

  useEffect(() => {
    if (products.length > 0 && detail.logi_product_id) {
      handleChange('logi_product_id', String(detail.logi_product_id));
    }
  }, [products]);

  return (
    <>
      <Modal
        title={`Nuevo Detalle de Grupo de Productos Panetones`}
        model={detail}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity="sale/panettone_group_product_details"
        dataForce={{
          group_product_id: id,
          logi_product_id: dataChanging.logi_product_id,
        }}
      >
        <Autocomplete
          disableClearable
          options={products}
          getOptionLabel={(item) => `(${item.ItemCode}) ${item.ItemName}`}
          renderInput={(params) => (
            <TextField {...params} label="Producto" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange('logi_product_id', item?.id);
          }}
          value={products.find((prod) => String(prod.id) === String(dataChanging.logi_product_id)) || null}
        />
      </Modal>
    </>
  );
});
